import React from 'react';
import { 
  Box, 
  Dialog, 
  Divider, 
  Typography,
  DialogContent,  
} from '@mui/material';
import UserCard from '../tabs/community/UserCard';
import MySkeleton from '../../../components/Skeleton';
import UserProfileDetails from './UserProfileDetails';
import ronan from '../../../assets/images/users/ronan.png';
import CommonModalHeader from '../../../components/DialogUi/CommonModalHeader';

interface IUserProfileDetails {
  userData?: any;
  loading?: boolean;
  openUserProfileDetails: boolean;
  handleopenUserProfileDetails: (flag: boolean) => void;
}

const StaticUserCardData = [
  {
    mem: { id: 1, displayName: 'John Doe', bio: 'Software Engineer', imageUrl: ronan, category: 'Alumni' },
  },
  {
    mem: { id: 2, displayName: 'Jane Doe', bio: 'Product Manager', imageUrl: ronan, category: 'Student' },
  },
  {
    mem: { id: 3, displayName: 'Alice Smith', bio: 'Data Scientist', imageUrl: ronan, category: 'Alumni' },
  },
  {
    mem: { id: 4, displayName: 'Bob Johnson', bio: 'UX Designer', imageUrl: ronan, category: 'Student' },
  },
];

const UserProfileDetailsPopup: React.FC<IUserProfileDetails> = ({
  loading,
  userData,
  openUserProfileDetails,
  handleopenUserProfileDetails
}) => {

  const handleOnSelectMember = (selectedMember : any) => {
    console.log(`Selected member: ${selectedMember}`);
  };

  return (
    <Dialog
      open={openUserProfileDetails}
      onClose={() => handleopenUserProfileDetails(false)}
      disableEnforceFocus
      scroll="body"
      fullWidth
    >
      <CommonModalHeader
        title={'Member profile details'}
        handleCloseModal={() => handleopenUserProfileDetails(false)}
      />
      <DialogContent className='px-20'>
        <UserProfileDetails
          data={userData}
          loading={false}
        />
        
        <Divider />

        {/* Similar Profiles */}
        {/* <Box pt={2}>
          <Box pb={2}>
            <Typography variant="h5">
              {loading ? (<MySkeleton variant="text" height={16} width={150} />) : 'Similar Profiles'}
            </Typography>
          </Box>
          <Box display={'flex'} gap={2} overflow={'auto'}>
            {StaticUserCardData.map((userData, index) => (
              <Box key={index} minHeight={'200px'} minWidth={'200px'} pb={2}>
                <UserCard 
                  mem={userData.mem} 
                  category={userData.mem.category}
                  cardWidth={'200px'}
                  cardHeight={'200px'} 
                  displayName={(userData.mem, 'displayName', '')}
                  bio={userData.mem.bio}
                  imageUrl={userData.mem.imageUrl}
                  communityMembers={''}
                  allCommunityMembersList={''}
                  handleOnSelectMember={handleOnSelectMember}
                  loading={loading}
                />
              </Box>  
            ))}
          </Box>
        </Box> */}
      </DialogContent>
    </Dialog>
  );
};

export default UserProfileDetailsPopup;
